<div appFlexLayout="column" [formGroup]="fLinks">

  <div appFlex>
    <span appFlex="grow"></span>
    <button [disabled]="!(this.fLinks.valid)" mat-raised-button class="mat-accent ml-16 white-text"
      (click)="save()">{{'Enregistrer'|translate}}</button>
  </div>

  <mat-checkbox name="notAnnotateOnly" formControlName="hasRedirectionLinks">
    {{'Activer les liens de redirection'|translate}}
  </mat-checkbox>

  <ng-container *ngIf="fLinks.controls.hasRedirectionLinks.value === true">

    <mat-form-field appFlex="50">
      <mat-label>{{'Complété'|translate}}</mat-label>
      <input type="text" matInput formControlName="complete" />
    </mat-form-field>

    <mat-form-field appFlex="50">
      <mat-label>{{'Rejeté / Disqualifié'|translate}}</mat-label>
      <input type="text" matInput formControlName="screenout" />

    </mat-form-field>

    <div appFlex="100">
      <span class="mat-subtitle-1">{{'Paramètres requis dans l\'URL'|translate}}</span>
      <ul>
        <li *ngFor="let param of params">{{param}}</li>
      </ul>
    </div>

  </ng-container>

</div>